import { getNodesFromConnection } from '../../utils/graphql'
import {
  CheckUsernameDocument,
  GetMyRolesDocument,
  GetSuggestUsernamesDocument,
  GetUserArtworkLikedCountDocument,
  GetUserBlockListDocument,
  GetUserCardSetProgressDocument,
  GetUserInfoByIdDocument,
  GetUserInfoByUsernameDocument,
  GetUserRolesDocument,
  ListActiveCollectionCardSetsDocument,
  ListUserActiveDecorationsDocument,
  ListUserCardSetProgressDocument,
  ListUserCollectionCardsDocument,
  ListUserFollowersDocument,
  ListUserFollowingsDocument,
  ListUsersDocument,
  ReportDocument,
  SetBlockStateDocument,
  SetFollowStateDocument,
} from './generated/graphql'
import {
  createFetchQueryHelper,
  createMutationHelper,
  createQueryHook,
  modifyQueryHook,
} from './utils'

export const useGetSuggestUsernames = modifyQueryHook(
  createQueryHook(GetSuggestUsernamesDocument),
  {
    reduce: r => r?.suggestUsernames,
  },
)

export const fetchListUsers = createFetchQueryHelper(ListUsersDocument)

export const useListUsers = modifyQueryHook(
  createQueryHook(ListUsersDocument),
  {
    reduce: r => r?.users,
  },
)

export const useGetUserInfoById = modifyQueryHook(
  createQueryHook(GetUserInfoByIdDocument),
  {
    transform: (userId: string) => ({ userId }),
    reduce: r => r?.user,
  },
)

export const useGetUserInfoByUsername = modifyQueryHook(
  createQueryHook(GetUserInfoByUsernameDocument),
  {
    transform: (username: string) => ({ username }),
    reduce: r => r?.user,
  },
)

export const useUserBlockList = createQueryHook(GetUserBlockListDocument)

export const fetchGetUserInfoByUsername = createFetchQueryHelper(
  GetUserInfoByUsernameDocument,
)

export const fetchCheckUsername = createFetchQueryHelper(CheckUsernameDocument)

export const useGetUserActiveDecorations = modifyQueryHook(
  createQueryHook(ListUserActiveDecorationsDocument),
  {
    reduce: r => r?.user?.activeDecorations,
  },
)

export const [useSetFollowState, executeSetFollowState] = createMutationHelper(
  SetFollowStateDocument,
)

export const [useSetBlockState, executeSetBlockState] = createMutationHelper(
  SetBlockStateDocument,
)

export const useListUserCollectionCards = modifyQueryHook(
  createQueryHook(ListUserCollectionCardsDocument),
  {
    reduce: r => r?.user?.collectionCards,
  },
)

export const useListActiveCollectionCardSets = modifyQueryHook(
  createQueryHook(ListActiveCollectionCardSetsDocument),
  {
    reduce: r => r?.activeCollectionCardSets,
  },
)

export const useGetUserCardSetProgress = modifyQueryHook(
  createQueryHook(GetUserCardSetProgressDocument),
  {
    reduce: r => r?.user?.collectionCardSetProgress,
  },
)

export const useListUserCollectionCardSetProgress = modifyQueryHook(
  createQueryHook(ListUserCardSetProgressDocument),
  {
    reduce: r => r?.user?.collectionCardSetProgresses,
  },
)

export const useGetUserArtworkLikedCount = modifyQueryHook(
  createQueryHook(GetUserArtworkLikedCountDocument),
  {
    transform: (userId: string) => ({ userId }),
    reduce: r => r?.user?.artworkLikedCount,
  },
)

export const useGetUserRoles = modifyQueryHook(
  createQueryHook(GetUserRolesDocument),
  {
    reduce: r => ({
      roles: getNodesFromConnection(r?.user?.roles),
      pageInfo: r?.user?.roles?.pageInfo,
    }),
  },
)

export const useGetMyRoles = modifyQueryHook(
  createQueryHook(GetMyRolesDocument),
  {
    reduce: r => getNodesFromConnection(r?.me?.roles),
  },
)

export const [, executeReport] = createMutationHelper(ReportDocument)

export const fetchListUserFollowings = createFetchQueryHelper(
  ListUserFollowingsDocument,
)

export const fetchListUserFollowers = createFetchQueryHelper(
  ListUserFollowersDocument,
)

export const useListUserFollowings = modifyQueryHook(
  createQueryHook(ListUserFollowingsDocument),
  { reduce: r => r?.user?.followings },
)

export const useListUserFollowers = modifyQueryHook(
  createQueryHook(ListUserFollowersDocument),
  { reduce: r => r?.user?.followers },
)
